import React from "react";

interface JobDetailBodyProps {
  children: React.ReactNode;
  className?: string;
}

/* The enclosed matter. Capped at a readable measure rather than filling
   the column: the index rail freed the width, and spending it all on line
   length would have made the prose harder to read, not easier. */
export const JobDetailBody: React.FC<JobDetailBodyProps> = ({
  children,
}) => {
  return (
    <div
      style={{
        display: "grid",
        gap: 52,
        maxWidth: 780,
      }}
    >
      {children}
    </div>
  );
};
